import React from 'react';
import {Toast} from 'antd-mobile';

let uuid = (function(){
    let id = 0;
    return ()=>{
        id++;
        return `file-id-${id}`;
    }
})();
class SelectFile extends React.Component{
    onChange = (evt)=>{
        let target = evt.currentTarget;
        let files = target.files;
        // 文件大小验证
        let validateFiles = [], invalidateFiles = [];
        for(let index = 0, len = files.length; index < len; index++){
            let file = files[index];
            if (file.size > (this.props.file_size_limit || 5*1024* 1024)){
                invalidateFiles.push(file);
            }else{
                file.id = uuid();
                validateFiles.push(file);
            }
        }

        let select = this.props.select;
        select && select(validateFiles);
        // 大小不符合规定
        if (invalidateFiles.length){
            let errorStr = []
            for (let file of invalidateFiles){
                errorStr.push(file.name);
            }
            Toast.info(`${errorStr.join(',') + $st("超过图片大小限制")}`, 2);
        }

        
    }
    // 如果支持水印, 只允许拍照  is_watermark
    render(){
        return (
            <div className="image-item" style={{border: '1px solid #DDD'}}>
                <span className="upload-add-h"></span>
                <span className='upload-add-v'></span>
                <input type='file' accept="image/*" onChange={this.onChange} value={''} capture={ this.props.is_watermark ? 'camera': ''}/> 
            </div>
        )
    }
}
export default SelectFile;



// WEBPACK FOOTER //
// ./src/component/Image/SelectFile.js